import type { NotificationShopPreferencesApiClient } from '@fourthwall/services/dist/NotificationShopPreferencesApiClient'

import type { FormValues } from '../Checkout.types'

export type Payload = Parameters<
  typeof NotificationShopPreferencesApiClient.updateNotificationShopPreferences
>[0]

const getCartAbandonedType = (values: FormValues) => {
  if (values.abandonedCheckoutEmailFrequency === 'light') {
    return 'LIGHT'
  }

  if (values.abandonedCheckoutEmailFrequency === 'recommended') {
    return 'RECOMMENDED'
  }

  return 'NONE'
}

export const getCartAbandonmentPayload = (values: FormValues) => {
  return {
    mailPreferences: {
      cartAbandoned: {
        type: getCartAbandonedType(values),
      },
      cartAbandonedIncludePromoCode: values.cartAbandonedIncludePromoCode,
    },
  } as Payload
}
